import React, {ChangeEvent, useState} from 'react';
import {InputFieldProps} from "./InputField";
import convert, {Unit} from "convert";
import {useField} from "formik";
import {Input} from "../Control";

// Types ----

export type ConvertedNumberFieldProps = Omit<InputFieldProps, 'type'> & {
  fieldUnit: Unit
  inputUnit: Unit
}

// Component ----

function ConvertedNumberField({fieldUnit, inputUnit, ...props}: ConvertedNumberFieldProps) {
  const [field, meta, {setValue}] = useField(props);

  const [displayValue, setDisplayValue] = useState<number>(
    convert(Number(field.value), fieldUnit).to(inputUnit)
  );

  const precision = (props.step ?? '1')
    .toString()
    .split('.')[1]
    ?.length;

  const error = (meta.touched && !!meta.error) ? meta.error : null

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    const inputValue = Number(e.currentTarget.value);
    const fieldValue = convert(inputValue, inputUnit).to(fieldUnit);

    void setValue(fieldValue.toFixed(precision));
    setDisplayValue(inputValue);
  }

  return (
    <Input
      type="number"
      value={displayValue.toFixed(precision)}
      onChange={handleChange}
      error={error}
      {...props}
    />
  );
}

export default ConvertedNumberField;